import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Card from '../components/Card'
import Carousel from '../components/Carousel'
import Video from '../components/Video'
import MediaPlayer from '../components/MediaPlayer'
import NotFound from './NotFound'

import { Row, Content } from '../components/Layout.js'

class News extends Component {
  componentWillMount () {
    this.props.setModal(true)
  }

  render () {
    if (!this.props.news || this.props.news.length === 0) {
      return (
        <div className='loading-modal'>
          <div className='spinner'>
            <div className='bounce1' />
            <div className='bounce2' />
            <div className='bounce3' />
          </div>
        </div>
      )
    }

    const newsitem = this.props.news.filter((newsitem) => newsitem.id === this.props.match.params.newsitem)[0] || null
    if (!newsitem) {
      this.props.setModal(false)
      return <NotFound />
    }

    return (
      <div className='modal'>
        <section>
          <Row classes={['marginBottom']}>
            <Content classes={['contentFull']}>
              <h1 dangerouslySetInnerHTML={{__html: newsitem.title}} />
              <h3 dangerouslySetInnerHTML={{__html: newsitem.subtext}} />
            </Content>
          </Row>
          <Carousel itemsToShow={1} autoplay={false}>
            {
              newsitem.carousel.map(function (item, index) {
                if (item.type === 'image') { return <Card full options={{image: item.url}} key={index} /> }
                if (item.type === 'video') { return <Video full video options={{video: item.url}} key={index} /> }
                if (item.type === 'vimeo') { return <MediaPlayer full video options={{video: item.url}} key={index} /> }
                return false
              })
            }
          </Carousel>
          <Row classes={['marginBottom']}>
            <Content classes={['contentFull']}>
              <p dangerouslySetInnerHTML={{__html: newsitem.fulltext}} />
            </Content>
          </Row>
        </section>
      </div>
    )
  }
}

News.propTypes = {
  setModal: PropTypes.func,
  news: PropTypes.array,
  match: PropTypes.object
}

export default News



// WEBPACK FOOTER //
// ./src/containers/News.js